import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <p>{`Using this connector requires either PostHog Cloud with the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/organization/billing"
      }}>{`data pipeline add-on`}</a>{`, or a self-hosted PostHog instance running `}<a parentName="p" {...{
        "href": "/blog/the-posthog-array-1-30-0"
      }}>{`version 1.30.0`}</a>{` or later.`}</p>
    <p>{`Self-hosting and not running 1.30.0? Find out `}<a parentName="p" {...{
        "href": "/docs/runbook/upgrading-posthog"
      }}>{`how to update your self-hosted PostHog deployment`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      